<template>
  <v-textarea
    :value="value"
    dense
    outlined
    :hide-details="hideDetails"
    class="rmr-input rmr-textarea"
    :class="{ 'rmr-input--md': size === 'md' }"
    v-bind="$attrs"
    v-on="listeners"
  />
</template>

<script>
export default {
  name: "RmrTextarea",
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    hideDetails: {
      type: [Boolean, String],
      default: true,
    },
    size: {
      type: String,
      default: "sm",
      validator: (v) => ["sm", "md"].includes(v),
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: (value) => this.$emit("input", value),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./_rmr-input.scss";

.rmr-textarea {
  &.rmr-input--md {
    ::v-deep .v-textarea__slot textarea {
      font-size: 14px;
      line-height: 1.5;
    }
  }
}
</style>